module.exports = __webpack_public_path__ + "img/slide-08-map.d28c12ef.svg";